import React, { useEffect, useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import {
  FormGroup,
  Checkbox,
  FormControlLabel,
  Typography,
  Grid,
} from '@material-ui/core';
import OptionChainStrategyTree from './OptionChainStrategy';
import OptionsFiltersTree from './OptionFilters';
import OptionChainStrategyRadioButtons from './OptionChainStrategyRadioButtons';
import { resolveOptionPriceMultiplier } from '../../../../../classes/tradePlan/tradePlanClasses/returnValidOptions';

const OPTION_INSTRUMENTS = ['option', 'future_option'];

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

export const OptionInstrumentDetails = ({ top, optionsManagement }) => {
  const classes = useStyles();
  const [
    buyOrSellOption,
    setBuyOrSellOption,
    itm,
    setItm,
    otm,
    setOtm,
    notExpiringToday,
    setNotExpiringToday,
  ] = optionsManagement;
  return (
    <Grid item container>
      <Grid item xs={2}>
        <FormControl variant="outlined" className={classes.formControl}>
          <InputLabel id="simple-select-outlined-label">
            <Typography style={{ fontSize: 10 }}>Buy/Sell Opt</Typography>
          </InputLabel>
          <Select
            labelId="simple-select-outlined-label"
            id="simple-select-outlined"
            //defaultValue="LONG"
            value={buyOrSellOption}
            onChange={(ev) => setBuyOrSellOption(ev.target.value)}
            label="Buy or Sell Option"
            style={{ width: 60, height: 30 }}
          >
            <MenuItem value="LONG">
              <Typography style={{ fontSize: 10 }}>Long</Typography>
            </MenuItem>
            <MenuItem value="SHORT">
              <Typography style={{ fontSize: 10 }}>Short</Typography>
            </MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid item container xs={10} justifyContent="space-evenly">
        <FormControl component="fieldset" className={classes.formControl}>
          <FormGroup row>
            <Grid item xs={3}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={itm}
                    onChange={(ev) => setItm(ev.target.checked)}
                    name="ITM"
                  />
                }
                labelPlacement={'top'}
                label={<Typography style={{ fontSize: 10 }}>ITM</Typography>}
              />
            </Grid>
            <Grid item xs={3}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={otm}
                    onChange={(ev) => setOtm(ev.target.checked)}
                    name="OTM"
                  />
                }
                labelPlacement={'top'}
                label={<Typography style={{ fontSize: 10 }}>OTM </Typography>}
              />
            </Grid>
            <Grid item xs={3}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={notExpiringToday}
                    onChange={(ev) => setNotExpiringToday(ev.target.checked)}
                    name="not expiring today"
                  />
                }
                style={{ width: 100 }}
                label={
                  <Typography style={{ fontSize: 10 }}>
                    not expiring today
                  </Typography>
                }
                labelPlacement={'top'}
              />
            </Grid>
          </FormGroup>
        </FormControl>
      </Grid>
    </Grid>
  );
};

const OptionsManagement = (props) => {
  const classes = useStyles();

  let top = props.top;
  let dispatchTop = props.dispatchTop;
  const [
    tightSpreadPctEnabled,
    setTightSpreadPctEnabled,
    tightSpreadCentsEnabled,
    setTightSpreadCentsEnabled,
    optionPriceRangeEnabled,
    setOptionPriceRangeEnabled,
    tightSpreadPct,
    dispatchTightSpreadPct,
    tightSpreadCents,
    dispatchTightSpreadCents,
    optionPriceRange,
    dispatchOptionPriceRange,
    qtyRangeEnabled,
    setQtyRangeEnabled,
    dollarRangeEnabled,
    setDollarRangeEnabled,
    qtyRange,
    dispatchQtyRange,
    dollarRange,
    dispatchDollarRange,
    hugCurrentPriceEnabled,
    setHugCurrentPriceEnabled,
    hugCurrentPrice,
    dispatchHugCurrentPrice,
    setViewOptionManagementEnabled,
    expirationDates,
    setExpirationDates,
    setBuyOrSellOption,
    otm,
    setOtm,
    itm,
    setItm,
    notExpiringToday,
    setNotExpiringToday,
    ShowExpirationDates,
    optionChoices,
    setOptionChoices,
    optionChains,
    setOptionChains,
    symbolsUsed,
    setSymbolsUsed,
    otm1Enabled,
    setOtm1Enabled,
    otm1,
    dispatchOtm1,
    itm1Enabled,
    setItm1Enabled,
    itm1,
    dispatchItm1,
  ] = props.optionsManagement;
  let entryTactics = props.entryTactics;
  useEffect(() => {
    //jStat()
    const convertToSpreads = async (optionChains, optionChoices) => {
      const spreads = [];
      const chainAsObject = {};
      if (Object.keys(optionChains).length > 0) {
        Object.values(optionChains['chains']).forEach((chain) => {
          Object.values(chain).forEach((options) => {
            Object.values(options).forEach((o) => {
              let option = o; /* JSON.parse(o); */
              chainAsObject[option.symbol] = option;
            });
          });
        });
      }
      //   console.log(chainSpreads);
      let best = 1000; //.. as iterate through here...
      // console.log(optionChoices);

      let qtyBasisValue = 0;
      if (entryTactics['MARKET_ORDER'] !== undefined) {
        qtyBasisValue = entryTactics['MARKET_ORDER']['quantityBasisValue'];
      } else if (entryTactics['LIMIT_ORDER'] !== undefined) {
        qtyBasisValue = entryTactics['LIMIT_ORDER']['quantityBasisValue'];
      } else if (entryTactics['CANDLE_BREAK'] !== undefined) {
        qtyBasisValue = entryTactics['CANDLE_BREAK']['quantityBasisValue'];
      }
      let passFilterCount = 0;
      let choices = optionChoices.choices;
      for (let i in choices) {
        let expireDate = choices[i];
        for (let index in expireDate) {
          let oc = expireDate[index];
          let option = chainAsObject[oc];
          if (option === undefined) {
            continue;
          }
          let passesFilters = true;
          if (tightSpreadPctEnabled) {
            let spread = tightSpreadPct.maxOptionSpreadPct;
            let optionSpread = (option.ask - option.bid) / option.ask;
            if (optionSpread > spread) {
              passesFilters = false;
            }
          }
          if (otm) {
            //believe option chain message has quote;
            let quote = optionChains.quote;
            let midQuotePrice = (quote.bid + quote.ask) / 2;
            if (option.strike < midQuotePrice) {
              passesFilters = false;
            }
          }
          if (itm) {
            let quote = optionChains.quote;
            let midQuotePrice = (quote.bid + quote.ask) / 2;
            if (option.strike > midQuotePrice) {
              passesFilters = false;
            }
          }
          if (tightSpreadCentsEnabled) {
            let cents = tightSpreadCents.maxOptionSpreadCents;
            let optionCents = option.ask - option.bid;
            if (optionCents > cents) {
              passesFilters = false;
            }
          }
          if (optionPriceRangeEnabled) {
            let mid = (option.bid + option.ask) / 2;
            if (
              mid <= optionPriceRange.minPrice ||
              mid >= optionPriceRange.maxPrice
            ) {
              passesFilters = false;
            }
          }

          if (dollarRangeEnabled) {
            let min = dollarRange.minDollar;
            let max = dollarRange.maxDollar;
            let mid = (option.bid + option.ask) / 2;
            let priceMultiplier = resolveOptionPriceMultiplier(
              option,
              top.instrument
            );
            let expectedDollar = qtyBasisValue * mid * priceMultiplier;
            if (expectedDollar <= min || expectedDollar >= max) {
              passesFilters = false;
            }
          }
          if (qtyRangeEnabled) {
            let min = qtyRange.minQty;
            let max = qtyRange.maxQty;
            let mid = (option.bid + option.ask) / 2;
            let priceMultiplier = resolveOptionPriceMultiplier(
              option,
              top.instrument
            );
            let expectedQty = qtyBasisValue / mid / priceMultiplier;
            if (expectedQty <= min || expectedQty >= max) {
              passesFilters = false;
            }
          }
          if (passesFilters) {
            passFilterCount++;
          }
        }
      }
      return { count: passFilterCount };
    };
    if (entryTactics) {
      convertToSpreads(optionChains, optionChoices).then((stats) => {
        if (props.setOptionsAvailable) {
          props.setOptionsAvailable(stats.count);
        }
        //console.log(stats.count);
      });
    }
  }, [
    optionChoices,
    optionChains,
    tightSpreadPct,
    tightSpreadPctEnabled,
    tightSpreadCents,
    tightSpreadCentsEnabled,
    qtyRangeEnabled,
    qtyRange,
    dollarRange,
    dollarRangeEnabled,
    optionPriceRangeEnabled,
    optionPriceRange,
    otm,
    itm,
    props.entryTactics,
  ]);

  return (
    <div className="m-2">
      {OPTION_INSTRUMENTS.includes(top.instrument) ? (
        <>
          <Grid item container>
            <Grid item xs={7}>
              <OptionChainStrategyRadioButtons
                hugCurrentPriceEnabled={hugCurrentPriceEnabled}
                setHugCurrentPriceEnabled={setHugCurrentPriceEnabled}
                dispatchHugCurrentPrice={dispatchHugCurrentPrice}
                hugCurrentPrice={hugCurrentPrice}
                otm1Enabled={otm1Enabled}
                setOtm1Enabled={setOtm1Enabled}
                otm1={otm1}
                dispatchOtm1={dispatchOtm1}
                itm1Enabled={itm1Enabled}
                setItm1Enabled={setItm1Enabled}
                itm1={itm1}
                dispatchItm1={dispatchItm1}
              />
            </Grid>
            <Grid item xs={5}>
              <OptionsFiltersTree
                optionsAvailable={props.optionsAvailable}
                optionPriceRange={[
                  optionPriceRangeEnabled,
                  setOptionPriceRangeEnabled,
                  optionPriceRange,
                  dispatchOptionPriceRange,
                ]}
                tightSpreadPct={[
                  tightSpreadPctEnabled,
                  setTightSpreadPctEnabled,
                  tightSpreadPct,
                  dispatchTightSpreadPct,
                ]}
                tightSpreadCents={[
                  tightSpreadCentsEnabled,
                  setTightSpreadCentsEnabled,
                  tightSpreadCents,
                  dispatchTightSpreadCents,
                ]}
                qtyRange={[
                  qtyRangeEnabled,
                  setQtyRangeEnabled,
                  qtyRange,
                  dispatchQtyRange,
                ]}
                dollarRange={[
                  dollarRangeEnabled,
                  setDollarRangeEnabled,
                  dollarRange,
                  dispatchDollarRange,
                ]}
                top={top}
                startExpanded
              />
            </Grid>
          </Grid>
        </>
      ) : (
        <React.Fragment />
      )}
    </div>
  );
};
/*

*/

export default OptionsManagement;
